import Card from 'react-bootstrap/Card';

function StatCard({
  label,
  value,
  icon,
  loading,
  bg = 'var(--color-purple-ghost)',
  color = 'var(--color-purple-primary)',
}) {
  return (
    <Card
      className="h-100 border-0 card-elevated"
      style={{ borderRadius: 'var(--radius-md)', backgroundColor: '#fff' }}
    >
      <Card.Body className="d-flex align-items-center gap-2 p-3">
        {icon && (
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 'var(--radius-sm)',
              backgroundColor: bg,
              color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {icon}
          </div>
        )}
        <div style={{ minWidth: 0, width: '100%' }}>
          <div className="text-muted text-truncate" style={{ fontSize: 12 }}>{label}</div>
          {loading ? (
            <div className="skeleton-bar" style={{ width: '60%', height: 19, marginTop: 2 }} />
          ) : (
            <div className="fw-bold" style={{ fontSize: 19, color: 'var(--color-neutral)' }}>{value}</div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default StatCard;
